/**
 * DialRecording component.
 */
import Container from '@components/atoms/container/dialRecordingContainer';
import Icon from '@components/atoms/icons/recordStart';

/**
 * Dial recording props.
 */
export interface Props {
  display: boolean;
}

/**
 * Displays the dial recording component.
 */
export default function DialRecording({ display }: Props) {
  return (
    <Container display={display}>
      <Icon />
    </Container>
  );
}
